import { createContext } from "react";

/**
 * Unit Context Interface
 *
 * Manages the unit system (metric/yards) with two levels:
 * 1. Default preference (from ClientConfig, set in debug modal's client config form)
 * 2. Session override (temporary, resets when session ends)
 */
export interface UnitContextValue {
  unit: "metric" | "yards";
  /** Client config default unit (ignores session override) */
  defaultUnit: "metric" | "yards";
  /** Set unit for current session only (temporary override) */
  setUnit: (unit: "metric" | "yards") => void;
  /** Reset to client config default unit */
  resetToDefault: () => void;
}

/**
 * Unit Context
 *
 * Provides unit system state management for the application.
 * Session overrides reset to default when session ends.
 */
export const UnitContext = createContext<UnitContextValue | undefined>(
  undefined
);
